import React from 'react';
import { CheckIcon } from 'lucide-react';
type Props = {
  items: readonly string[];
  tone?: 'dark' | 'light';
  columns?: boolean;
};
export function CheckList({
  items,
  tone = 'light',
  columns = false
}: Props) {
  return <ul className={`grid gap-3 ${columns ? 'md:grid-cols-2 md:gap-x-8' : ''}`} data-id="element-341" data-mp="2gj7cwupda66o">
      {items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-342" data-mp="2lkd9x4q28fm0">
          <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full ${tone === 'dark' ? 'bg-cyan text-ink' : 'bg-success text-white'}`} data-id="element-343" data-mp="2qiychassbbdm">
            <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-344" data-mp="2zbruhfzm8ov6" />
          </span>
          <span className={`text-[16px] font-medium leading-snug ${tone === 'dark' ? 'text-white/90' : 'text-heading'}`} data-id="element-345" data-mp="3488hg6v2wx6o">
            {item}
          </span>
        </li>)}
    </ul>;
}